<template>
  <div class="box">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 右边内容 -->
    <div class="content-right">
      <!-- 标题 个人中心 -->
      <p class="person-title">我的活动</p>
      <!-- 主要内容 -->
      <div class="person-main">
        <div v-if="mydata.userActivityArr.length === 0">
          <p
            style="
              line-height: 300px;
              text-align: center;
              letter-spacing: 1px;
              color: #999999;
            "
          >
            暂无活动
          </p>
        </div>
        <div class="box-myActivityCards" v-else>
          <myActivityCards
            v-for="(item, index) in mydata.userActivityArr"
            :key="index"
            :info="item"
            :showUploadFileBtn="!item.files && mydata.userInfo.user_role === 3"
            :showViewWorksBtn="mydata.userInfo.user_role === 1"
            @showUploadFileBtnClick="toActivity"
            @showUploadFileBtnClick2="toActivity2"
            :studentApplyInfoObj="mydata.studentApplyInfoObj"
          ></myActivityCards>
        </div>
        <!--分页 -->
        <div class="gl-pagination">
          <el-pagination
            v-model:currentPage="mydata.pageObj.currentPage"
            v-model:page-size="mydata.pageObj.pageSize"
            :total="mydata.pageObj.total"
            layout="prev, pager, next"
            pager-count="4"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
// 是否来自其他模块
let fromOtherModule = false;
// 缓存组件
import { defineComponent } from "vue";
export default defineComponent({
  name: "myActivity",
  beforeRouteEnter(to, from, next) {
    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
    if (
      [
        // '/layout/list/researchDetails',
        "/layout/list/thematicDetails",
      ].includes(from.path) === false
    ) {
      fromOtherModule = true;
      // console.log('来自其他模块');
    }
    next();
  },
});
</script>



<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
import { useRouter, useRoute } from "vue-router";

import { reactive, computed, toRefs, onActivated } from "vue";

import myActivityCards from "@/views/personalCenter/components/myActivityCards/index2.vue";

import { ElMessage } from "element-plus";
// import { ComponentSize, FormInstance, FormRules } from "element-plus";

// import {
//   Delete,
//   Download,
//   Plus,
//   ZoomIn,
//   Warning,
// } from "@element-plus/icons-vue";

// import { UploadFile } from "element-plus";

// 引入接口
import {
  userActivityList,
  studentApplyUpdate,
  studentApplyInfo,
} from "@/api/personalCenter/myActivity/index.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  size: "default",

  // currentPage3: "5",
  // pageSize3: "100",
  // small: false,
  // background: false,
  // disabled: false,

  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
  sizeList: ["small"],

  // path: "/layout/list/myActivityDetails",
  path: "/layout/list/thematicDetails",

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 4, // 每页条数
    total: 0, // 总的条数
  },
  userActivityArr: [], //用户活动列表
  studentApplyInfoObj: {}, //学生报名详情
});

onActivated(() => {
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
  // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
    mydata.userInfo = JSON.parse(localStorage.getItem("userInfo")) ?? {}; //用户信息
    // path: "/layout/list/myActivityDetails",
    mydata.path = "/layout/list/thematicDetails";

    mydata.pageObj = {
      currentPage: 1, // 当前页数
      pageSize: 4, // 每页条数
      total: 0, // 总的条数
    };
    mydata.userActivityArr = []; //用户活动列表
    userActivityFn();
  }
  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false;

  // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
  // getSubject();
});

const { circleUrl, sizeList } = toRefs(mydata);

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  userActivityFn();
}

// 获取文章列表
function userActivityFn() {
  userActivityList(mydata.userInfo.jwt, {
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // 文章列表
    mydata.userActivityArr = res.data.list;
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}

// 查询
// userActivityFn();

// function myActivityDetailsButton() {
//   router.push({
//     path: "/layout/list/myActivityDetails",
//   });
// }

function toActivity(info) {
  console.log(info);
  // activity_type   1课题研究   2专题活动
  // let path =
  //   info.activity_type === 1
  //     ? "/layout/list/thisEventRegistrationTeacher"
  //     : "/layout/list/thisEventRegistrationStudent";

  // 课题研究页面的教师加入活动
  let path = "/layout/list/thisEventRegistrationTeacher";

  router.push({
    path: path,
    query: {
      activityId: info.id,
      article_id: info.article_id,
      id: info.article_id,
      isEnrolled: true,
      isSubmitFileUrl: false,
    },
  });
}


//自定义事件的函数 ----  学生加入活动的 查看作品
function toActivity2(info) {
  //学生报名详情
  studentApplyInfo({
    id: info.id,
  }).then((res) => {
    // console.log(res.data, "获取学生报名详情");
    mydata.studentApplyInfoObj = res.data;

    if (res.data.status === -1) {
      // 提示弹窗
      ElMessage({
        message: "作品审核未通过，请重新上传文件！",
        type: "error",
      });
    }
  });
}






</script>

<style scoped lang="scss">
.box {
  ////右边内容
  .content-right {
    // width: 1012px;
    // height: 784px;
    background-color: #ffffff;
    // border:1px solid rgb(0, 255, 34);
    // padding-left: 62px;
    // position: relative;
    // padding-bottom: 40px;
    margin-top: 16px;
    overflow: hidden;
    //标题 我的图书
    .person-title {
      font-size: 16px;
      font-weight: 700;
      color: #282828;
      letter-spacing: 1px;
      line-height: 54px;
      padding: 0px 16px;
      border-bottom: 2px solid #e4e7ed;
      // margin-bottom:40px;
    }

    //主要内容
    .person-main {
      // width: px;
      // border:1px solid red;
      /////
      .box-myActivityCards {
        // height: 1040px;
        // border:1px solid red;
        min-height: 500px;
        // border: 1px solid blue;

        .box {
          margin-top: 16px;
        }
      }
      //////////分页
      .paging {
        // margin: 0 auto;
        display: flex;
        justify-content: center;
        margin-top: 40px;
        margin-bottom: 40px;
        :deep(.el-button.is-plain) {
          margin-left: 24px;
        }
      }
      //最左边的箭头
      :deep(.btn-prev.is-first) {
        margin-right: 12px;
        background-color: #f5f6f7;
      }
      :deep(.btn-next) {
        background-color: #f5f6f7;
      }
      //每个页
      :deep(.number) {
        margin-right: 12px;
        // color:#BBBDBF;
        background-color: #f5f6f7;
      }
      //省略号
      :deep(.more.btn-quicknext.el-icon) {
        margin-right: 12px;
        background-color: #f9f9f9;
      }

      .demo-pagination-block + .demo-pagination-block {
        margin-top: 10px;
      }
      .demo-pagination-block .demonstration {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
